import { Subject } from 'rxjs';
import {
  Component,
  OnInit,
  ViewChildren,
  HostListener,
  Input,
  EventEmitter,
  Output,
  AfterViewInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  QueryList,
} from "@angular/core";
import { Router } from "@angular/router";
import { QuestionList } from "../../models/bank-question-list.model";
import { QuestionFilterPipe } from "./../../pipes/question-filter.pipe";
import { SourceInfoService } from "../../../shared/services/source-info.service";
import { ShareDataService } from "../../services/shared.service";
import { environment } from "../../../../environments/environment";
import { PageEvent } from "../pager";
import { ButtonPurpose } from "../button/button-purpose";
import { SelectedBankQuestionsService } from "../../services/selected-bank-questions.service";

import { KebabMenuInterface } from "./../../../shared/models/kebab-menu-model";
import { KeyAction } from "src/app/utils/keyActions";
import { closeOpenTooltips, getKebabElements } from "src/app/utils/shared-utils";
import { CheckboxComponent } from "../checkbox";
import { TooltipDirective } from "../tooltip";
import { SelectSourceQuestion } from "../../models/select-source-question.model";
import { LiveAnnouncer } from "@angular/cdk/a11y";
import { FOOTER_OFFSET_HEIGHT, LARGE_VIEW_HEIGHT_OFFSET_BODY, MEDIUM_SCREEN_BREAKPOINT_PX, MEDIUM_SCREEN_HEIGHT_BREAKPOINT_PX, QUESTION_ADDED_SUCCESS_MESSAGE, SMALL_VIEW_HEIGHT_OFFSET_BODY } from 'src/app/utils/stringConstants';

@Component({
    selector: "source-bank",
    templateUrl: "./source-bank.component.html",
    styleUrls: ["./source-bank.component.scss"],
    standalone: false
})
export class SourceBankComponent implements OnInit, AfterViewInit {
  private error;
  private droppedQuestions = [];
  droppedIndex: number = null;
  checkedQuestion = true;
  sourceInfoData = [];
  title = { selected: false };
  checked = false;
  initialEvent = {};
  selectedQuestions = [];
  similarQuestionsBothPanel = [];
  selectedQuestionsToMove = [];
  selectAllQuestions = [];
  hasMultiple = false;
  hasExpanded: boolean = false;
  screenHeight: number = null;
  screenWidth: number = null;
  totalQuestion: number = 0;
  sourcePickerCompHeight: number = null;
  sourcePickerCompHeightBody: number = null;
  direction: number;
  isDesc: any;
  totalSearchCount: number = 0;
  column: any;
  questionCollection: any = {};
  previewUrl = [];
  qIndex: Number;
  closeModalPopUp: Boolean;
  public algoImgUrl =
    environment.assests + "/assets/img/connect_sprite_icon2.png";
  kebabMenu: KebabMenuInterface;
  sectionBreakKebabMenu: KebabMenuInterface;
  partQuestionKebabMenu: KebabMenuInterface;
  partQuestionNoDeleteKebabMenu: KebabMenuInterface;
  sectionBreakNoDeleteKebabMenu: KebabMenuInterface;
  moveToTestPanelKebabMenu: KebabMenuInterface;
  searchResultsAnnouncement: string = "";
  public kebabIndex: any;
  public deleteText: string = "Delete";
  public deleteMessage: String;
  public showQuestionDelete: boolean = false;
  public warningImage = environment.assests + "/assets/img/warning.png";
  private deletedObject: any;
  private isPartQuestion: any;
  private parentQuestionIndex: any;
  public _buttonPurpose = ButtonPurpose;
  sectionTableWidth: string = "width:73%";
  public ExpandToggleText: string = "Expand All";

  previewHeaderText: string = "Previewing my questions";
  isPreviewSourceQuestions: boolean = false;
  public questionIndex: any = "0";
  grabbedQuestion: SelectSourceQuestion;
  public grabbedIndex: number;
  public deselectedIndex: number;
  public shortcutsModalIsVisible: boolean = false;
  public temporaryStateForAdd: boolean = false;
  public isMacOS: boolean;
  public isModalOpen: boolean = false;
  private sourcePickerHeightOffset: number = 323;

  constructor(
    private sourceInfoService: SourceInfoService,
    private questionListPipe: QuestionFilterPipe,
    private shareDataService: ShareDataService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private sourceBankQuestionService: SelectedBankQuestionsService,
    private liveAnnouncer: LiveAnnouncer
  ) {
    this.onResize();
  }

  @Input("question-list") questionList: QuestionList;
  @Input("filters-list") filterList: QuestionList;
  @Input("dropped-questions") droppedQuestionList;
  @Input("panel-Expanded") panelExpanded;
  @Input("truncate-Title") truncateTitle;
  @Input("text-search") searchedText = "";
  @Input("filter-count") filterCount: number = 0;
  @Input() isFilterPopupOpen: boolean = false;
  @Input() filterAnnouncementRegion: ElementRef | null = null;
  @ViewChildren("mySelectedBank") item;
  @Output() enableAdd = new EventEmitter<number>();
  @Output() singleItemClicked = new EventEmitter<number>();
  @Output() emitAddQuestion = new EventEmitter<number>();
  @Output() addToTestPanel = new EventEmitter<SelectSourceQuestion[]>();
  @Output() addToTestPanelTemp = new EventEmitter<SelectSourceQuestion[]>();
  @Output() sourceDrag = new EventEmitter<boolean>();
  @ViewChild('selectAllCheckbox') selectAllCheckbox!: CheckboxComponent;
  @ViewChildren(TooltipDirective) dragHandleTooltips: QueryList<TooltipDirective>;
  @ViewChild('leftList') leftList?: ElementRef;
  public questionListKebab: any = [];
  questionHideArray = new Map();
  expandAllSubject = new Subject<void>();
  currentPageIndex: number = 0;
  firstItemIndex: number = 0;
  totalLength: number = 1;
  pageSize: number = 20;
  widthQuestionDisplay: number;
  headQuestion: string = "head-question-default";
  ngOnInit() {
    this.sort("typeDesc");
    this.kebabMenu = {
      addNewPart: false,
      get_info: false,
      preview: true,
      pinUnpin: false,
      edit: false,
      copy: false,
      export: false,
      rename: false,
      print: false,
      delete: true,
      remove: false,
      pastUsage: true,
      editQuestion: true,
      copyAndEdit: true,
    };
    this.moveToTestPanelKebabMenu = {
      addNewPart: false,
      get_info: false,
      preview: false,
      pinUnpin: false,
      edit: false,
      copy: false,
      export: false,
      rename: false,
      print: false,
      delete: false,
      remove: false,
      pastUsage: false,
      editQuestion: false,
      copyAndEdit: false,
      moveToTestPanel: true
    };
    this.sectionBreakKebabMenu = {
      addNewPart: false,
      get_info: false,
      preview: true,
      pinUnpin: false,
      edit: false,
      copy: false,
      export: false,
      rename: false,
      print: false,
      delete: true,
      remove: false,
      pastUsage: true,
      editQuestion: true,
      copyAndEdit: true,
      moveToTestPanel: true
    };
    this.sectionBreakNoDeleteKebabMenu = {
      addNewPart: false,
      get_info: false,
      preview: true,
      pinUnpin: false,
      edit: false,
      copy: false,
      export: false,
      rename: false,
      print: false,
      delete: false,
      remove: false,
      pastUsage: true,
      editQuestion: true,
      copyAndEdit: true,
      moveToTestPanel: true
    };
    this.partQuestionKebabMenu = {
      addNewPart: false,
      get_info: false,
      preview: true,
      pinUnpin: false,
      edit: false,
      copy: false,
      export: false,
      rename: false,
      print: false,
      delete: true,
      remove: false,
      pastUsage: true,
      editQuestion: true,
      copyAndEdit: true,
    };
    this.partQuestionNoDeleteKebabMenu = {
      addNewPart: false,
      get_info: false,
      preview: true,
      pinUnpin: false,
      edit: false,
      copy: false,
      export: false,
      rename: false,
      print: false,
      delete: false,
      remove: false,
      pastUsage: true,
      editQuestion: true,
      copyAndEdit: true,
    };
    this.assignArrayIndex();
    this.isMacOS = navigator.userAgent.toLowerCase().includes("mac");
  }
  ngAfterViewInit() {
    this.assignArrayIndex();
    this.cdr.detectChanges();
  }
  assignArrayIndex() {
    let arrayIndex = 0;
    if (this.questionList) {
      this.questionList["itemInfo"].questions.forEach((item) => {
        item["index"] = arrayIndex++;
        this.questionHideArray.set(item.qid + "-main", false);
        if (item.hasOwnProperty("parts")) {
          item["parts"].map((val) => {
            this.questionHideArray.set(val.qid + "-parts", false);
          });
        }
        item = this.partQuestionAddIndex(item);
      });
    }
  }

  @HostListener("document:click", ["$event"])
  clickout(event) {
    const { kebabButton, kebabIcon } = getKebabElements(event.target);

    if (!kebabButton && !kebabIcon) {
      this.kebabIndex = -1;
    }
    if (document.getElementsByClassName("ahe-ui-alert-modal").length > 0) {
      this.kebabIndex = -1;
    }
    if (!this.panelExpanded) {
      this.headQuestion = "head-question-default";
      this.sectionTableWidth = "width:73%";
    } else {
      this.headQuestion = "head-question-fullWidth";
      this.sectionTableWidth = "width:78%";
    }
  }

  /**
   * Reset temporary add state and grabbed question on mouse interaction.
   * Used to switch from keyboard to mouse mode for drag/select actions.
   */
  @HostListener('document:mousedown', ['$event'])
  public onMouseDown() {
    if (this.grabbedQuestion) {
      // Reset keyboard interaction when switched to mouse interaction
      if (this.temporaryStateForAdd) {
        this.addToTestTemp(null);
      }
      this.resetGrabbedQuestion(this.grabbedIndex);
    }
  }

  OnCheckboxSelect(bank, event) {
    const index = this.selectedQuestions.indexOf(bank);
    const draggableIndex = this.selectedQuestionsToMove.indexOf(bank);
    // To initialize the array once selct all and then unselect one
    // Issue is once select all then unselect one also setting as blank array instead the rest of the values

    // For checkbox select unselect object
    if (event) {
      bank.selected = true;
      if (bank.hasOwnProperty("parts")) {
        bank.parts = bank.parts.map((partQuestion) => {
          partQuestion.selected = true;
          return partQuestion;
        });
      }

      if (index === -1) {
        this.selectedQuestions.push(bank);
        // Set selected question list
        this.shareDataService.setSelectedQuestions(this.selectedQuestions);
      }
    } else {
      bank.selected = false;
      if (bank.hasOwnProperty("parts")) {
        bank.parts = bank.parts.map((partQuestion) => {
          partQuestion.selected = false;
          return partQuestion;
        });
      }
      if (index !== -1) {
        this.selectedQuestions.splice(index, 1);
        // Set selected question list
        this.shareDataService.setSelectedQuestions(this.selectedQuestions);
      }
    }
    this.updateSelectAllCheckboxState();
    this.sendMessage();
  }

  /**
   * Updates the state of the select-all checkbox based on individual question selections.
   * Sets the checkbox to:
   * - checked: when all visible questions are selected
   * - indeterminate: when some (but not all) visible questions are selected
   * - unchecked: when no visible questions are selected
   */
  private updateSelectAllCheckboxState(): void {
    if (!this.selectAllCheckbox) {
      return;
    }

    const filteredQuestions = this.getParsedArray();
    if (filteredQuestions.length === 0) {
      this.setSelectAllState(false, false);
      return;
    }
    const selectedCount = filteredQuestions.filter(q => q.selected).length;
    const totalCount = filteredQuestions.length;

    // Determine checkbox state based on selection
    if (selectedCount === 0) {
      this.setSelectAllState(false, false);
    } else if (selectedCount === totalCount) {
      this.setSelectAllState(true, false);
    } else {
      this.setSelectAllState(false, true);
    }
  }

  private setSelectAllState(checked: boolean, indeterminate: boolean): void {
    this.title.selected = checked;
    this.selectAllCheckbox.indeterminate = indeterminate;
  }

  public get selectAllAriaChecked(): 'true' | 'false' | 'mixed' {
    if (!this.selectAllCheckbox) {
      return 'false';
    }
    if (this.selectAllCheckbox.indeterminate) {
      return 'mixed';
    }
    return this.title.selected ? 'true' : 'false';
  }

  private unSelectAll() {
    this.title.selected = false;
    this.questionList.itemInfo.questions.forEach((item) => {
      item.selected = false;
    });
  }

  public trackByEzid(index, item) {
    return item.ezid;
  }
  selectAll(event) {
    const requiredResult = this.questionListPipe.transform(
      this.questionList.itemInfo.questions,
      this.filterList,
      true
    );
    if (event) {
      this.title = { selected: true };
    } else {
      this.title = { selected: false };
    }

    // Clear indeterminate state when selecting/deselecting all
    this.selectAllCheckbox.indeterminate = false;

    requiredResult.forEach((item) => {
      item.selected = event;
      if (item.hasOwnProperty("parts")) {
        item.parts = item.parts.map((partQuestion) => {
          partQuestion.selected = event;
          return partQuestion;
        });
      }

      if (item.selected && this.selectedQuestions.indexOf(item) === -1) {
        this.selectedQuestions.push(item);
        // Set selected question list
        this.shareDataService.setSelectedQuestions(this.selectedQuestions);
      } else if (!item.selected) {
        const index = this.selectedQuestions.indexOf(item);
        this.selectedQuestions.splice(index, 1);
        // Set selected question list
        this.shareDataService.setSelectedQuestions(this.selectedQuestions);
      }
    });
    this.sendMessage();
  }

  sendMessage() {
    this.enableAdd.emit(this.selectedQuestions.length);
  }

  @HostListener("window:resize", ["$event"])
  private onResize(event?) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;

    /**set source picker component height */
    this.sourcePickerCompHeight = this.screenHeight - this.sourcePickerHeightOffset;
    this.sourcePickerCompHeightBody = this.screenWidth > MEDIUM_SCREEN_BREAKPOINT_PX && this.screenHeight > MEDIUM_SCREEN_HEIGHT_BREAKPOINT_PX
      ? this.screenHeight - LARGE_VIEW_HEIGHT_OFFSET_BODY - FOOTER_OFFSET_HEIGHT
      : this.screenHeight - SMALL_VIEW_HEIGHT_OFFSET_BODY - FOOTER_OFFSET_HEIGHT;
  }
  selectBank() {
    this.router.navigate(["/", "sourceSelect"]);
  }

  private setSelectedRowColor() {
    if (this.shareDataService.getDroppedQuestionId() != undefined) {
      this.shareDataService.getDroppedQuestionId().forEach((item) => {
        const position = this.droppedQuestions.indexOf(item);
        if (!this.shareDataService.getDeletedQuestionId()) {
          this.droppedQuestions.push(item);
        }
      });
    }
  }

  // Check and remove the
  removeFromArray(original, rightPanel) {
    this.similarQuestionsBothPanel = original
      .filter((o1) => rightPanel.some((o2) => o1.qid === o2.qid))
      .map(function (item) {
        return item["qid"];
      });
  }

  ngOnChanges(event) {
    if (this.droppedQuestionList) {
      this.setSelectedRowColor();
      this.removeFromArray(
        this.questionList.itemInfo.questions,
        this.droppedQuestionList
      );
      this.unselectQuestions();
      this.updateSelectAllCheckboxState();
    }
    if (event.hasOwnProperty("filterList") || this.searchedText != "") {
      this.currentPageIndex = 0;
    }
    this.setQuestionCount(this.getParsedArray());
    this.currentPage();
    this.updateResultsAnnouncement();
  }
  getParsedArray() {
    let totalQuestionAR: any = [];
    if (Object.keys(this.filterList).length === 0) {
      totalQuestionAR = this.questionList.itemInfo.questions;
    } else {
      totalQuestionAR = this.questionListPipe.transform(
        this.questionList.itemInfo.questions,
        this.filterList,
        true
      );
    }
    if (this.searchedText != "") {
      totalQuestionAR = this.filterSearchedItem(totalQuestionAR);
    }
    return totalQuestionAR;
  }
  filterSearchedItem(totalQuestionAR) {
    const questionArray = [];
    totalQuestionAR.map((findData) => {
      let dataFound =
        findData.preview
          .toLowerCase()
          .search(this.searchedText.toLowerCase().trim()) !== -1;
      if (findData.hasOwnProperty("parts") && !dataFound) {
        for (let i = 0; i < findData.parts.length; i++) {
          if (
            findData.parts[i].preview
              .toLowerCase()
              .search(this.searchedText.toLowerCase().trim()) !== -1
          ) {
            dataFound = true;
            break;
          }
        }
      }
      if (dataFound) {
        questionArray.push(findData);
      }
    });
    this.totalSearchCount = questionArray.length;
    return questionArray;
  }
  setQuestionCount(totalQuestionAR) {
    let totalQuestion = 0;
    totalQuestionAR.map((val) => {
      if (val.hasOwnProperty("parts")) {
        totalQuestion += val.parts.length;
      } else {
        totalQuestion += 1;
      }
    });
    this.totalQuestion = totalQuestion;
  }
  unselectQuestions() {
    for (const data in this.questionCollection) {
      this.questionCollection[data].forEach((item) => {
        item.selected = false;
      });
    }
    this.selectedQuestions = [];
    this.unSelectAll();
  }
  filterData() {
    this.currentPageIndex = 0;

    return;
  }
  currentPage() {
    const collectionArray = {};
    const dataArray = this.getParsedArray();
    let pageNum = 0;
    for (let i = 0; i < dataArray.length; i += this.pageSize) {
      const chunk = dataArray.slice(i, i + this.pageSize);
      collectionArray[pageNum] = chunk;
      pageNum++;
    }
    this.totalLength = dataArray.length;
    this.questionCollection = { ...collectionArray };
    return this.questionCollection[this.currentPageIndex] || [];
  }
  fetchPage(event: PageEvent) {
    this.currentPageIndex = event.pageIndex;
    this.firstItemIndex = event.firstItemIndex;
    this.scrollQuestionListToTop();
    if (!!this.questionCollection[this.currentPageIndex]) {
      return;
    }
  }

  private scrollQuestionListToTop() {
    this.leftList?.nativeElement?.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }

  sort(property) {
    this.isDesc = !this.isDesc; //change the direction
    this.column = property;
    this.direction = this.isDesc ? 1 : -1;
  }

  public getOnlinePreviewUrl(question, index) {
    this.singleItemClicked.emit(question);
  }

  public closeModal(obj) {
    this.closeModalPopUp = !obj;
    this.isPreviewSourceQuestions = false;
    this.questionListKebab = [];
    this.questionIndex = "0";
  }
  sourceQuestionUpdate(val) {
    val = val.response.itemInfo.questions[0];
    var getPos: number = -1;
    getPos = this.shareDataService.getEditedQuestionIndex();

    if (getPos > -1) {
      let questType = this.shareDataService.getEditedQuestionType();

      if (questType == "section-break") {
        // sction break new question add

        this.questionList.itemInfo.questions[getPos].parts.push(val);
        this.assignArrayIndexSectionBreakQuestion(
          this.questionList.itemInfo.questions
        );
      } else if (questType == "section-break-part-question") {
        // section break part question edit or copyedit for my question
        let partInfo = this.shareDataService.getPartQuestionEditedInfo();
        if (
          partInfo.hasOwnProperty("multiPartId") &&
          partInfo.multiPartId != ""
        ) {
          var temp;
          temp = this.questionList.itemInfo.questions.map((item) => {
            if (partInfo.multiPartId == item.multiPartId) {
              if (partInfo.copyy === true) {
                item.parts.unshift(val);
              } else {
                var partQuesIndex = partInfo.index;
                item.parts[partQuesIndex] = val;
              }
            }
            return item;
          });
          this.questionList.itemInfo.questions = temp;
        }

        this.shareDataService.setPartQuestionEditedInfo({});
      } else if (questType == "section-break-part-question-copy-edit") {
        // section break part question edit for library question
        let partInfo = this.shareDataService.getPartQuestionEditedInfo();

        if (
          partInfo.hasOwnProperty("multiPartId") &&
          partInfo.multiPartId != ""
        ) {
          // Removed the existing item

          for (var i = this.questionList.itemInfo.questions.length; i--; ) {
            if (
              this.questionList.itemInfo.questions[i].multiPartId ==
              partInfo.multiPartId
            ) {
              this.questionList.itemInfo.questions.splice(i, 1);
            }
          }
        }

        this.questionList.itemInfo.questions.unshift(val);
        this.shareDataService.setPartQuestionEditedInfo({});
      } else {
        val = this.partQuestionAddIndex(val);
        this.questionList.itemInfo.questions[getPos] = val;
        // this.shareDataService.setEditedQuestionIndex(-1);
        //this.assignArrayIndexSectionBreakQuestion(this.selectedQuestionsListObj);
      }
      this.shareDataService.setEditedQuestionType("");
      this.shareDataService.setEditedQuestionIndex(-1);
    } else {
      val = this.partQuestionAddIndex(val);
      this.questionList.itemInfo.questions.unshift(val);
      // Announce question copied and added - source-bank copy flow
      this.liveAnnouncer.announce(QUESTION_ADDED_SUCCESS_MESSAGE, 'polite');
    }

    this.assignArrayIndex();
    //this.assignArrayIndexSectionBreakQuestion(this.questionList.itemInfo.questions);
    //this.arrayPinnedQuestions();
    //console.log('Left Panel Final Update');
    //console.log(this.questionList.itemInfo.questions);
  }
  partQuestionAddIndex(val) {
    if (val.hasOwnProperty("parts")) {
      let ind = 0;
      val.parts = val.parts.map((partQuestion) => {
        partQuestion.index = ind++;
        return partQuestion;
      });
    }
    return val;
  }

  deleteQuestion(val) {
    this.showQuestionDelete = true;
    this.deletedObject = val;
    this.deleteMessage = "msg3";
    if (this.deletedObject.refType == "multipart") {
      this.deleteMessage = "msg3";
    } else if (
      this.deletedObject.refType == "scalar" &&
      this.deletedObject.hasOwnProperty("multiPartId") &&
      this.deletedObject.multiPartId != ""
    ) {
      var noOfPartQuestion;
      var parentQuestionObj;
      this.questionList.itemInfo.questions.forEach((item) => {
        if (this.deletedObject.multiPartId == item.multiPartId) {
          noOfPartQuestion = item.parts.length;
          parentQuestionObj = item;
          this.parentQuestionIndex = item["index"];
        }
      });

      if (noOfPartQuestion == 1) {
        this.deleteMessage = "msg2";
        this.deletedObject = parentQuestionObj;
        this.isPartQuestion = false;
      } else {
        this.isPartQuestion = true;
        this.deleteMessage = "msg3";
      }
    }
  }

  closeConfirmModal() {
    this.showQuestionDelete = false;
    const response = this.sourceBankQuestionService
      .deleteQuestion(this.deletedObject)
      .subscribe(
        (data) => {
          if (this.isPartQuestion === true) {
            let pindex = this.parentQuestionIndex;
            this.questionList.itemInfo.questions[pindex].parts.splice(
              this.deletedObject.index,
              1
            );
            this.questionList.itemInfo.questions[pindex] =
              this.partQuestionAddIndex(
                this.questionList.itemInfo.questions[pindex]
              );
          } else {
            this.questionList.itemInfo.questions.splice(
              this.deletedObject.index,
              1
            );
            this.assignArrayIndex();
          }

          this.refreshQuestionCounter();
        },
        (error) => {
          this.error = error;
          console.log("Question delete error");
        }
      );
  }

  private refreshQuestionCounter(): void {
    this.setQuestionCount(this.getParsedArray());
    this.currentPage();
    this.updateResultsAnnouncement();
  }

  public setKebabIndex(index: any) {
    // If clicking on the same kebab that's already open, close it
    if (this.kebabIndex === index) {
      this.kebabIndex = -1;
      return;
    }
    this.kebabIndex = index;
  }
  closeDeleteModal() {
    this.showQuestionDelete = false;
    this.deletedObject = {};
  }
  indexCal(i, j) {
    return i + "." + j;
  }
  setWidthClass(panelExpanded, userEdited) {
    if (panelExpanded) {
      return "sec-td-wt-1";
    } else if (!panelExpanded && userEdited) {
      return "sec-td-wt-2";
    } else if (!panelExpanded && !userEdited) {
      return "sec-td-wt-3";
    } else if (panelExpanded && userEdited) {
      return "sec-td-wt-4";
    } else if (panelExpanded && !userEdited) {
      return "sec-td-wt-5";
    }
  }
  assignArrayIndexSectionBreakQuestion(data) {
    let len = this.questionList.itemInfo.questions.length;
    for (var i = 0; i <= len; i++) {
      if (this.questionList.itemInfo.questions[i].hasOwnProperty("parts")) {
        let ind = 0;
        let partslen = this.questionList.itemInfo.questions[i].parts.length;
        for (var j = 0; j <= partslen; j++) {
          this.questionList.itemInfo.questions[i].parts[j]["index"] = j;
        }
      }
    }
    /*this.questionList.itemInfo.questions = data.map((question) => {
        if( question.hasOwnProperty("parts")){
           let ind = 0;
            question.parts.map((partQuestion) => {
                 partQuestion.index = ind++;
                 return partQuestion;
            }) ;
        }
        return question;
    });   */
  }

  emitQuestionInfo(selectedQuestionsListObj) {
    this.singleItemClicked.emit(selectedQuestionsListObj);
  }

  addQuestionClicked(obj) {
    this.emitAddQuestion.emit(obj);
  }

  private uncheckedAddedQuestions(addedQuestions) {
    this.questionList.itemInfo.questions
      .filter((o1) => addedQuestions.some((o2) => o1.qid === o2.qid))
      .map(function (item) {
        item.selected = false;
      });

    const filterSelectedQuestions = this.selectedQuestions
      .filter((o1) => addedQuestions.some((o2) => o1.qid === o2.qid))
      .map(function (item) {
        return item;
      });

    var newFilterSelectedQuestions = this.selectedQuestions.filter(
      (element) => !filterSelectedQuestions.includes(element)
    );
    if (newFilterSelectedQuestions) {
      this.selectedQuestions = JSON.parse(
        JSON.stringify(newFilterSelectedQuestions)
      );
    }
    this.shareDataService.setSelectedQuestions(this.selectedQuestions);
  }
  toggleQuestionHideArray(questionId: string) {
    const isExpand = this.questionHideArray.get(questionId);
    this.questionHideArray.set(questionId, !isExpand);

    const allExpanded = [...this.questionHideArray.values()].every(
      isExpanded => isExpanded
    );
    this.hasExpanded = allExpanded;
    this.ExpandToggleText = allExpanded ? "Collapse All" : "Expand All";
  }
  expandAllToggle(isAnnouncementRequired: boolean = true) {
    this.hasExpanded = !this.hasExpanded;
    this.questionHideArray.forEach((values, keys) => {
      this.questionHideArray.set(keys, this.hasExpanded);
    });
    this.cdr.detectChanges();
    this.expandAllSubject.next();
    if (this.hasExpanded) {
      this.ExpandToggleText = "Collapse All";
    } else {
      this.ExpandToggleText = "Expand All";
    }
    if (isAnnouncementRequired) this.liveAnnouncer.announce(`${this.ExpandToggleText} for Add From`, 'polite');
  }
  noReturnPredicate() {
    return false;
  }

  addToTest(question: SelectSourceQuestion): void {
    const questions = [question];
    this.addToTestPanel.emit(questions);
  }

  // adds temporarily to the test panel for preview, used for keyboard interaction
  addToTestTemp(question?: SelectSourceQuestion): void {
    const questions = question ? [question] : [];
    this.addToTestPanelTemp.emit(questions);
  }

  /**
   * Handles the click/enter/space event on a drag handle for a question.
   * Resets any previously grabbed question, sets the new one, and closes tooltips.
   */
  dragHandleClicked(question: SelectSourceQuestion, index: number): void {
    if (this.grabbedQuestion) {
      this.resetGrabbedQuestion(this.grabbedIndex);
    }
    this.setGrabbedQuestion(question, index);
    closeOpenTooltips(this.dragHandleTooltips);
  }

  /**
   * Handles keyboard events for drag-and-drop interactions on source bank questions.
   * - On Enter or Space key:
   *   - If in temporary add state, adds the grabbed question to the test and resets the grabbed question.
   *   - Otherwise, sets the grabbed question and closes any open tooltips.
   * - On Escape key:
   *   - Cancels the temporary add state and resets the grabbed question.
   * - On Ctrl/Meta + ArrowRight:
   *   - If a question is grabbed, enters temporary add state and adds the question preview to the test panel.
   */
  dragHandlerKeydown(event: KeyboardEvent, question: SelectSourceQuestion, index: number): void {
    if (this.grabbedQuestion || event.key === KeyAction.Space) {
      // if a question is already grabbed, prevent default to avoid default browser behavior of keys like tab, enter, etc.
      event.preventDefault();
    }
    if (event.key === KeyAction.Enter || event.key === KeyAction.Space) {
      if (this.temporaryStateForAdd) {
        this.addToTest(this.grabbedQuestion);
        this.resetGrabbedQuestion(index);
        (event.target as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      else {
        this.setGrabbedQuestion(question, index);
        closeOpenTooltips(this.dragHandleTooltips);
      }
    }
    else if (event.key === KeyAction.Escape) {
      this.addToTestTemp(null);
      this.resetGrabbedQuestion(index);
      (event.target as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    else if (this.grabbedQuestion && !this.temporaryStateForAdd &&
      ((event.ctrlKey || event.metaKey) && event.key === KeyAction.ArrowRight)) {
      this.temporaryStateForAdd = true;
      this.addToTestTemp(this.grabbedQuestion);
    }
  }

  private setGrabbedQuestion(question: SelectSourceQuestion, index: number): void {
    this.grabbedQuestion = question;
    this.grabbedIndex = index;
    this.deselectedIndex = null;
  }

  private resetGrabbedQuestion(questionIndex: number): void {
    this.grabbedQuestion = null;
    this.grabbedIndex = null;
    this.deselectedIndex = questionIndex;
    this.temporaryStateForAdd = false;
  }
  /**
   * Programmatically focuses the "Select All" checkbox in the question list.
   * This method is intended to improve accessibility by allowing keyboard users
   * or assistive technologies to move focus directly to the "Select All" checkbox.
   * Call this method after add to test action.
   */
  public focusSelectAllCheckbox(): void {
    if (this.selectAllCheckbox) {
      this.selectAllCheckbox.focus();
    }
  }

  /*
    updateResultsAnnouncement function is invoked in response to user actions such as performing a search, applying filters, or a combination of both.
    Here's how the updateResultsAnnouncement() method handles messaging in various scenarios:
    -Search only: "X search results found for '<user_input>'"
    -Filter only: "X search results found matching <no_of_filters> selected filters"
    -Search + Filter: "X search results found for '<user_input>' and <no_of_filters> selected filters"
    -Search reset or cleared (full list view): "X search results"
  */
  private updateResultsAnnouncement() {
    const resultCount = this.totalQuestion;
    const resultLabel = `${resultCount} search result${resultCount !== 1 ? 's' : ''}`;
    let announcement = "";
    if (this.searchedText.trim().length >= 1  && this.filterCount > 0) {
      announcement = `${resultLabel} found for '${this.searchedText.trim()}' and ${this.filterCount} selected filter${this.filterCount > 1 ? 's' : ''}`;
    } else if (this.searchedText.trim().length >= 1) {
      announcement = `${resultLabel} found for '${this.searchedText.trim()}'`;
    } else if (this.filterCount > 0) {
      announcement = `${resultLabel} found matching ${this.filterCount} selected filter${this.filterCount > 1 ? 's' : ''}`;
    } else {
      announcement = resultLabel;
    }
      if (!this.isFilterPopupOpen) {
        this.searchResultsAnnouncement = announcement;
      } else {
        if (this.filterAnnouncementRegion) {
          this.filterAnnouncementRegion.nativeElement.textContent = announcement;
        }
      }
  }

  onModalStateChanged(isOpen: boolean) {
    this.isModalOpen = isOpen;
  }

  checkTooltipPresent(): boolean {
    return this.dragHandleTooltips.some(tooltip => tooltip.isOpen());
  }
}
